import type { MRT_DisplayColumnDef } from "material-react-table";
import { useMemo } from "react";

import { Contrato } from "@/shared/interfaces";

export const useClientesCorporativosCostosColumns = () => {
  //   const clientesFibraOpticaReturnUrl = ROUTER_PATHS.contabilidad.clientesCoorporativosNav;

  ///* basic -----------------------
  const clientesCorporativosCostosColumns = useMemo<
    MRT_DisplayColumnDef<Contrato>[]
  >(
    () => [
      {
        accessorKey: "codigo",
        header: "codigo",
        size: 200,
      },
      {
        accessorKey: "numero_referencia",
        header: "numero referencia",
        size: 200,
      },
      {
        accessorKey: "nombre",
        header: "nombre",
        size: 200,
      },
      {
        accessorKey: "descripcion",
        header: "descripcion",
        size: 200,
      },
      {
        accessorKey: "costo",
        header: "costos",
        size: 200,
      },
      {
        accessorKey: "cif",
        header: "cif",
        size: 200,
      },
      {
        accessorKey: "mano_obra_directa",
        header: "mano de obra directa",
        size: 200,
      },
      {
        accessorKey: "mano_obra_indirecta",
        header: "mano de obra indirecta",
        size: 200,
      },
    ],
    []
  );

  return {
    clientesCorporativosCostosColumns,
  };
};
